import { Avatar, Box, Grid, IconButton, Toolbar, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import logo from '../../src/assets/img/logo_espolads.png';
import { InstitucionalPalette, themePalette } from "../config/theme.config";
import { SignOutButton } from "../helpers/EntraID/SignOutButton";
import { LoggedUser } from "../types/Usuario/LoggedUser";
import AvatarMenu from "./User/AvatarMenu";
import { Iconify } from "./iconify";
import { useDispatch } from "react-redux";
import { setCookie } from "typescript-cookie";
import { outUser } from '../redux/slices/auth.slice';

type HeaderProps = {
    user: LoggedUser,
    foto?: string,
    isTest?: boolean
}

export const HeaderLogIn: React.FC<HeaderProps> = ({ user, foto, isTest = false }) => {
    const theme = useTheme();
    const isXSmallScreen = useMediaQuery(theme.breakpoints.down('xs'));
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const dispatch = useDispatch();
    //#region variables
    const navigate = useNavigate();
    //#endregion
    //#region function
    const goToNavigation = (site: string) => {
        navigate(site)
    }
    const logout = () => {
        dispatch(outUser());
        setCookie("tokenEspolAds", "", { path: "/", expires: new Date(0) });
        {window.location.href = "/";}
    }
    const imgSizes = () => {
        if (isXSmallScreen) {
            return 150;
        } else if (isSmallScreen) {
            return 150;
        } else {
            return 300;
        }
    };
    //#endregion
    const w = imgSizes();
    return (
        <Box sx={{ flexGrow: 1, backgroundColor: themePalette.BGWHITE }} >
            <Toolbar>
                <Grid container
                    direction={'row'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                >
                    <Grid item xs={6} sm md lg xl>
                        <Box sx={{ m: 1, ml: 10 }} >
                            <img src={logo} alt="Logo" style={{ width: w, height: 'auto' }} />
                        </Box>
                    </Grid>
                    <Grid item>
                        <Box sx={{ color: InstitucionalPalette.PRIMARY, textAlign: 'right', mr: 2 }}>
                            <AvatarMenu usuario={user.usuario} roles={user.roles} />
                        </Box>
                    </Grid>
                    {/* <Grid item>
                        <Avatar className='avatarNav'
                            alt="foto-usuario"
                            src={foto}
                            style={{ width: '80px', height: '80px', borderRadius: '10px', margin:'5px' }}
                        />
                    </Grid> */}
                    <Grid item>
                        {isTest ?
                            <IconButton onClick={() => logout()}>
                                <Iconify icon='streamline:logout-1-solid' width={40} color={InstitucionalPalette.PRIMARY} />
                            </IconButton>
                            :
                            <SignOutButton color={InstitucionalPalette.PRIMARY} />
                        }
                    </Grid>
                </Grid>
            </Toolbar>
        </Box>
    );
}